import React from 'react';
import { Icon } from 'b3';

var stageToIcon = {
    1: <div className="client-stage-with-icon"><Icon icon="award-3" /> Evaluation</div>,
    2: <div className="client-stage-with-icon"><Icon icon="setting-gear" /> Setup</div>,
    3: <div className="client-stage-with-icon"><Icon icon="profile-2" /> Demo</div>,
    4: <div className="client-stage-with-icon"><Icon icon="artboard" /> Training</div>,
    5: <div className="client-stage-with-icon"><Icon icon="dollar-bag" /> Paying</div>
};

export default function ClientStageWithIcon({clientStageId}) {
    var icon = stageToIcon[clientStageId];  

    if(! icon) {
        throw new Error(`Could not find an icon for clientStageId ${clientStageId}`);
    }

    return icon;
}


// WEBPACK FOOTER //
// ./app/components/clients/ClientStageWithIcon.js